import React from "react";
import {V2GlassChip} from "./V2Glass";

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
    children: React.ReactNode;
    variant?: "pill" | "comment";
}

function V2PhotoOverlayChip({children, className, variant = "pill", ...props}: Props) {
    const classes = [
        "v2-photo-overlay-chip",
        variant === "comment" ? "v2-photo-overlay-chip-comment" : undefined,
        className,
    ].filter(Boolean).join(" ");

    return <V2GlassChip className={classes} {...props}>{children}</V2GlassChip>;
}

export default V2PhotoOverlayChip;
